import FormComponent from '../FormComponent';

class KeyPoints extends FormComponent {
	markup(value, data = {}, titleMarkup = '') {
		const {
			hasSeperator,
			wrapperClasses = 'u-mb-5',
			innerClass = 'u-mb-5',
			customStylingClass,
			subtitle,
			subtitleStyleClass = 'u-h4',
			instructionText,
			instructionTextStyleClass = 'u-p1'
		} = data;

		const separator = hasSeperator ? '<div class="separator"></div>' : '';

		const wrapperClass = `lta-richtext ${wrapperClasses} u-pt-0`;
		const contentWrapperClass = customStylingClass
			? ''
			: `class="rt-keypoint__secondary" style="--lta-theme--1: var(--color-lta-accent-bright-blue)"`;

		const subtitleMarkup = subtitle ? `<div class="${subtitleStyleClass}">${subtitle}</div>` : '';

		const instructionMarkup = instructionText
			? `<div class="${instructionTextStyleClass}">${instructionText}</div>`
			: '';

		return `
			${separator}
			<div class="${wrapperClass}">
				<div class="${innerClass}">${titleMarkup}</div>
				<div ${contentWrapperClass}>
					${subtitleMarkup}
					${instructionMarkup}
				</div>
			</div>
		`;
	}
}

export default KeyPoints;
